/*-----------------------------------------------------------------
- Schedule demo
-----------------------------------------------------------------*/
export default {
    title             : 'demo planla',
    contact_us_text   : 'Herhangi bir acil sorunuz varsa, lütfen bizimle $hello@Quarkino.com$ adresinden iletişime geçmekten çekinmeyin.',
    interested_service: 'İlgilenen Hizmet',
    select_service    : 'Bir Hizmet Seçin',
    file              : 'Dosya',
    demo_req_submitted: 'Demo Talebi Gönderildi!',
    can_schedule      : 'Artık demonuzu planlayabilirsiniz.',
    full_name         : 'Ad Soyad',
    email_address     : 'E-posta adresi',
    uploader_content  : 'dosya eki',
};
